export let dto_selected_merchant_or_product = {
  PID: Number,
  Code: String,
  Description: String,
  GDescription: String,
  UP: Number,
  UD: Number,
  CATID: Number,
  IsAvailable: Boolean,
  ProductImageUrl: String,
  ProductGroupId: Number,
  MaxQty: Number,
  MID: Number,
  Merchant: String,
  ImageURL: String,
  IO: Boolean,
  MinBillValue: Number,
  MaxBillValue: Number,
  MobileAppUIType: String,
  ASO: Boolean,  
  AllowInstanceOrder: Boolean,
  MT: String,
  ZoneID: Number,
  Zone: String,
  DineType: Number,
};

export let dto_selected_final_merchant_or_product = {
  PID: Number,
  Code: String,
  Description: String,
  GDescription: String,
  UP: Number,
  UD: Number,
  CATID: Number,
  IsAvailable: Boolean,
  ProductImageUrl: String,
  ProductGroupId: Number,
  MaxQty: Number,
  MID: Number,
  Merchant: String,
  ImageURL: String,
  IO: Boolean,
  MinBillValue: Number,
  MaxBillValue: Number,
  MobileAppUIType: String,
  AllowScheduledOrder: Boolean,
  AllowInstanceOrder: Boolean,
  MT: String,
  ZoneID: Number,
  Zone: String,
};
